const OPEN_DELETE_STRATEGY_WIZARD = 'OPEN_DELETE_STRATEGY_WIZARD';
const CLOSE_DELETE_STRATEGY_WIZARD = 'CLOSE_DELETE_STRATEGY_WIZARD';

export { OPEN_DELETE_STRATEGY_WIZARD, CLOSE_DELETE_STRATEGY_WIZARD };
